export default "__VITE_ASSET__ba8ef15d__"